(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('dialogService', dialogService);

    /* @ngInject */
    function dialogService($uibModal) {
        var service = {
            confirm: confirm,
            info: info,
            custom: custom
        };

        activate();

        return service;

        function activate() {
        }

        function confirm(title, message) {
            var options = {
                animation: true,
                templateUrl: 'app/services/dialog/modal/dialog.confirm.modal.html',
                controllerAs: 'vm',
                controller: controller
            };

            /* @ngInject */
            function controller($uibModalInstance) {
                /*jshint validthis:true */
                var vm = this;
                vm.title = title || 'Are you sure ?';
                vm.message = message || 'This action is final!';

                vm.confirm = confirm;
                vm.reject = reject;

                function confirm() {
                    $uibModalInstance.close('confirmed');
                }

                function reject() {
                    $uibModalInstance.dismiss('rejected');
                }
            }

            var modalInstance = $uibModal.open(options);

            return modalInstance.result;
        }

        function info(title, message) {
            var options = {
                animation: true,
                templateUrl: 'app/services/dialog/modal/dialog.info.modal.html',
                controllerAs: 'vm',
                controller: infoController
            };

            /* @ngInject */
            function infoController($uibModalInstance) {
                /*jshint validthis:true */
                var vm = this;
                vm.title = title || 'Successful';
                vm.message = message || 'The action was successfully completed!';

                vm.close = close;

                function close() {
                    $uibModalInstance.close();
                }
            }

            var modalInstance = $uibModal.open(options);

            return modalInstance.result;
        }

        function custom(title, message, config) {
            var options = {
                animation: true,
                templateUrl: 'app/services/dialog/modal/dialog.custom.modal.html',
                controllerAs: 'vm',
                controller: customController
            };

            /* @ngInject */
            function customController($uibModalInstance) {
                /*jshint validthis:true */
                var vm = this;
                vm.title = title || 'Successful';
                vm.message = message || 'The action was successfully completed!';

                var defaultButton = { Text: 'Close', isConfirmation: false, IsPrimary: false, OnClick: dismiss };

                vm.buttons = [];

                vm.close = close;
                vm.onBtnClick = onBtnClick;

                activate();

                function activate() {
                    var btnConfig = !!config.Buttons ? angular.copy(config.Buttons) : [defaultButton];

                    if (!!config.Buttons) {
                        btnConfig.push(defaultButton);
                    }                    

                    vm.buttons = btnConfig;
                }

                function close() {
                    $uibModalInstance.close();
                    vm.buttons = [];
                }

                function dismiss() {
                    $uibModalInstance.dismiss();
                    vm.buttons = [];
                }

                function onBtnClick(button) {
                    
                    if (button.isConfirmation) {
                        close();
                        button.OnClick();
                    } else {
                        dismiss();
                    }                    
                }

            }

            var modalInstance = $uibModal.open(options);

            return modalInstance.result;
        }
    }
})();
